import {
    OBTENER_LLAVES,
    GET_CONFIG_FORM43,
    GET_DATOS_GESTION_IMPLICADO,
    GET_DATOS_GESTION_IMPLICADO_DEFAULT,
    POST_ACTUALIZAR_EXTRAJUDICIAL,
    GET_CONFIG_FORM39,
    GET_COMBO_INSTANCIAS_PRETENSIONES,
    GET_COMBO_POSIBILIDAD_ACUERDO,
    GET_PRETENSIONES_VIGENTES_IMPLICADO,
    GET_PROVISIONES_VIGENTES_IMPLICADO,
    GET_PRETENSIONES_IMPLICADOS,
    GET_HISTORIAL_PRETENSIONES_IMPLICADO,
    GET_LISTA_IMPLICADOS,
    GET_COMBO_MONEDAS,
    GET_COMBO_INSTANCIAS_PREVISIONES,

    GET_PROVISIONES_IMPLICADOS,
    GET_HISTORIAL_PROVISIONES_IMPLICADO,
    GET_COBERTURA_PROVISIONES,
    GET_TAREAS_PENDIENTES
} from '../types';


export default function administracionCasoReducer(state = {}, action) {
    switch (action.type) {
        case OBTENER_LLAVES:
            return { ...state, llaves: action.payload }
        case GET_CONFIG_FORM43:
            return { ...state, cfg_form43: action.payload }
        case GET_DATOS_GESTION_IMPLICADO:
            return { ...state, datosGestionImplicado: action.payload }
        case GET_DATOS_GESTION_IMPLICADO_DEFAULT:
            return { ...state, datosGestionImplicadoDefault: action.payload }
        case POST_ACTUALIZAR_EXTRAJUDICIAL:
            return { ...state, respuestaActGestionDefensa: action.payload }
        case GET_CONFIG_FORM39:
            return { ...state, cfg_form39: action.payload }
        case GET_COMBO_INSTANCIAS_PRETENSIONES:
            return { ...state, comboInstanciasPretensiones: action.payload }
        case GET_COMBO_INSTANCIAS_PREVISIONES:
            return { ...state, comboInstanciasPrevisiones: action.payload }
        case GET_COMBO_POSIBILIDAD_ACUERDO:
            return { ...state, comboPosibilidadesAcuerdo: action.payload }
        case GET_PRETENSIONES_VIGENTES_IMPLICADO:
            return { ...state, listaPretensionesVigentes: action.payload }
        case GET_PROVISIONES_VIGENTES_IMPLICADO:
            return { ...state, listaProvisionesVigentes: action.payload }
        case GET_PRETENSIONES_IMPLICADOS:
            return { ...state, listaPretensionesImplicados: action.payload }
        case GET_HISTORIAL_PRETENSIONES_IMPLICADO:
            return { ...state, listaHistorialPretensionesImplicado: action.payload }
        case GET_LISTA_IMPLICADOS:
            return { ...state, listaImplicados: action.payload }
        case GET_COMBO_MONEDAS:
            return { ...state, comboMonedas: action.payload }

        case GET_PROVISIONES_IMPLICADOS:
            return { ...state, listaProvisionesImplicados: action.payload }
        case GET_HISTORIAL_PROVISIONES_IMPLICADO:
            return { ...state, listaHistorialProvisionesImplicado: action.payload }
        case GET_COBERTURA_PROVISIONES:
            return { ...state, listaCoberturaProvisiones: action.payload }
        case GET_TAREAS_PENDIENTES:
            return { ...state, listaTareasPendientes: action.payload }
        default:
            return state
    }
}